import type {
  Doctor,
  LpuAddressList,
  SynonymPriceList,
  Urls,
  OtherCountryOfWork,
} from 'www/vue_components/common/DoctorPageLpuList/types'
import { ref, shallowRef } from 'vue'
import { defineStore } from 'pinia'

export default defineStore('externalDataStore', () => {
  const currentDate = ref('')
  const doctor = ref<Doctor | null>(null)
  const lpuAddressList = ref<LpuAddressList | null>(null)
  const synonymPriceList = ref<SynonymPriceList | null>(null)
  const isAppointmentOn = ref(false)
  const appointmentWillEnableTime = ref('')
  const lpuWithAppointmentIds = ref<number[]>([])
  const townTranslit = ref('')
  const townTimedelta = ref<number | null>(null)
  const urls = ref<Urls | null>(null)
  const otherCountriesOfWork = shallowRef<OtherCountryOfWork[]>([])

  const isMobile = window.MOBILE_VERSION

  return {
    currentDate,
    doctor,
    lpuAddressList,
    synonymPriceList,
    isAppointmentOn,
    appointmentWillEnableTime,
    lpuWithAppointmentIds,
    townTranslit,
    townTimedelta,
    urls,
    isMobile,
    otherCountriesOfWork,
  }
})
